import React, { Component } from 'react';
import FaqView from '../../views/faqView/FaqView';
import styled from 'styled-components';
import Navbar from '../../views/shared/navbar/Navbar';
import Footer from '../../views/shared/footer/Footer';

const PageWrapper = styled.div`
	width: 100%;
	height: 100vh;
`;

type Props = {};

type State = {};

class FaqPage extends Component<Props, State> {
	state = {};

	render() {
		return (
			<PageWrapper>
				<Navbar variant="blue" />
				<FaqView />
				<Footer />
			</PageWrapper>
		);
	}
}

export default FaqPage;
